module.exports = require('./helpers/bundle-url').getBundleURL('e6gRn') + "logo.c51670a8.svg";